<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        stateOptions: [], // ETC状态
        etcCardTypeOptions: [], // 卡类型
        paymentTypeOptions: [], // 付费类型
        form: [
          { // ETC卡号
            label: 'ETC卡号',
            value: 'etcId',
            type: 'input',
            placeholder: '请输入ETC卡号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'bindVehicle',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 服务商名称
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            placeholder: '请输入服务商名称',
          },
          { // ETC状态
            label: 'ETC状态',
            value: 'state',
            type: 'select',
            default: -1,
            placeholder: '请选择ETC状态',
          },
          { // 卡类型
            label: '卡类型',
            value: 'etcCardType',
            type: 'select',
            default: -1,
            placeholder: '请选择卡类型',
          },
          { // 付费类型
            label: '付费类型',
            value: 'paymentType',
            type: 'select',
            default: -1,
            placeholder: '请选择付费类型',
          },
          { // 产品名称
            label: '产品名称',
            value: 'productName',
            type: 'input',
            placeholder: '请输入产品名称',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SYS_STATE_DESC,ETC_SERVICE_PAYMENT_TYPE,ETC_CARD_TYPE',
    });
    this.searchBoxData.stateOptions = [ // ETC状态
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.paymentTypeOptions = [ // 付费类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
    this.searchBoxData.etcCardTypeOptions = [ // 卡类型
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[2],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
